import {
  FoodDetailsContent,
  FoodDetailsHeader,
  FoodDetailsInfo,
  StyledFoodDetails,
} from "./styled"
import { BackButton } from "components/Common/BackButton"
import Button from "components/Buttons/Button"
import FoodImage from "components/foodDetails/share/FoodImage"
import { useState } from "react"
import { useBackToHome } from "features/meal/hooks"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import { TopNavWrapper } from "components/Layouts/TopNavWrapper"
import useLogMealFromFood from "features/meal/hooks/logMeal/useLogMealFromFood"
import { IOpenFoodFactFoodSearchResult } from "model/food/types/openFoodFact.types"
import useOpenFoodFactForm from "features/food/hooks/openFoodFact/useOpenFoodFactForm"
import OpenFoodFactNameAndPortion from "components/foodDetails/share/OpenFoodFactNameAndPortion"
import OpenFoodFactDescription from "components/foodDetails/share/OpenFoodFactDescription"

import AppStyleCtaBox from "components/Common/AppStyleCtaBox"
import EditNutrientForm from "../share/EditNutrientForm"
import EditableNutrientInformation from "../share/EditableNutrientInformation"

interface IProps {
  onBack: () => void
  food: IOpenFoodFactFoodSearchResult
  mode: "add" | "log"
  onAdd?: (food: IOpenFoodFactFoodSearchResult) => void
}

const OpenFoodFactFoodDetails = (props: IProps) => {
  const { onBack, food, mode, onAdd } = props

  const [displaySection, setDisplaySection] = useState<
    "FOOD_FORM" | "EDIT_NUTRITION_FORM"
  >("FOOD_FORM")

  const { openFoodFact, onPortionChange, updateFoodAsManualNutrition } =
    useOpenFoodFactForm(food)

  const [isPortionValid, setIsPortionValid] = useState(true)

  const onPortionChangeHandler = (value: number) => {
    onPortionChange(value)
    setIsPortionValid(true)
  }

  const backToHome = useBackToHome()
  const { handleLogMealFromFood, logMealLoading } =
    useLogMealFromFood(backToHome)

  if (displaySection === "EDIT_NUTRITION_FORM") {
    return (
      <EditNutrientForm
        onClose={() => {
          setDisplaySection("FOOD_FORM")
        }}
        meal={openFoodFact}
        onSubmit={updateFoodAsManualNutrition}
      />
    )
  }

  return (
    <StyledFoodDetails>
      <FoodDetailsContent>
        <FoodImage previewImageUrl={food.previewImageUrl}>
          <TopNavWrapper>
            <FoodDetailsHeader>
              <BackButton onClick={onBack}>
                <ChevronLeftBtn />
              </BackButton>

              <div style={{ width: 24, height: 24 }}></div>
            </FoodDetailsHeader>
          </TopNavWrapper>
        </FoodImage>

        <FoodDetailsInfo>
          <OpenFoodFactNameAndPortion
            food={openFoodFact}
            unitValue={openFoodFact.unit}
            portionValue={openFoodFact.portion}
            onPortionChange={onPortionChangeHandler}
            setIsPortionValid={setIsPortionValid}
            calories={openFoodFact.calorie}
            gram={openFoodFact.gram}
          />

          <EditableNutrientInformation
            entry={openFoodFact}
            setEditMode={() => setDisplaySection("EDIT_NUTRITION_FORM")}
          />

          <OpenFoodFactDescription />
        </FoodDetailsInfo>
      </FoodDetailsContent>

      <AppStyleCtaBox>
        {mode === "log" ? (
          <Button
            onClick={() => handleLogMealFromFood(openFoodFact)}
            style={{ width: "100%" }}
            $type="primary"
            disabled={!isPortionValid}
            loading={logMealLoading}
          >
            Log this item
          </Button>
        ) : (
          <Button
            onClick={() => {
              onAdd?.(openFoodFact)
              onBack()
            }}
            style={{ width: "100%" }}
            $type="primary"
            disabled={!isPortionValid}
          >
            Add this item
          </Button>
        )}
      </AppStyleCtaBox>
    </StyledFoodDetails>
  )
}

export default OpenFoodFactFoodDetails
